import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Card,
  Typography,
  notification,
  Upload,
  Steps,
  Icon,
} from "antd";
import { distance, motion } from "framer-motion";
import {
  SearchOutlined,
  CarOutlined,
  CalendarOutlined,
  UserOutlined,
  EditOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import icon from "../assets/images/road-trip.png";
import colors from "../../assets/styles/colour";
import { useLocation, useNavigate } from "react-router-dom";
import dataService from "../../networks/api/service/dataService";
import dayjs from "dayjs";
const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { Step } = Steps;

const AddTrip = () => {
  const [current, setCurrent] = useState(0); // Step tracker
  const [form] = Form.useForm();
  const [vehicleList, setVehicleList] = useState([]);
const [driverList, setDriverList] = useState([]);
const [filterdata, setFilterdata] = useState({
  startDateTime: "",
  endDateTime: "",
  tripType: "",
  vehicleId: "",
  driver: "",
  startPoint: "",
  endPoint: "",
  personsInTrip: "",
  distanceTraveled: "",
  description: "",
  isComplete: false
});

const location = useLocation();
const navigate = useNavigate();
const tripToEdit = location.state?.tripToEdit;
useEffect(() => {
  if (tripToEdit) {
    form.setFieldsValue({
      startDateTime: tripToEdit.startDateTime ? dayjs(tripToEdit.startDateTime) : null,
      endDateTime: tripToEdit.endDateTime ? dayjs(tripToEdit.endDateTime) : null,
      tripType: tripToEdit.tripType,
      vehicleId: tripToEdit.vehicle?._id,
      driverId: tripToEdit.driver?._id,
      startPoint: tripToEdit.startPoint,
      endPoint: tripToEdit.endPoint,
      personsInTrip: tripToEdit.personsInTrip,
      distanceTraveled: tripToEdit.distanceTraveled,
      description: tripToEdit.description,
    });
  }
}, [tripToEdit, form]);
  const onFinish = async (values) => {
    try {

      
      const payload = {
        ...values,
        startDateTime: values.startDateTime?.toISOString() || "",
        endDateTime: values.endDateTime?.toISOString() || "",
        tripType: values.tripType,
        vehicle: values.vehicleId, 
        driver: values.driverId,   
        startPoint: values.startPoint,
        endPoint: values.endPoint,
        personsInTrip: Number(values.personsInTrip),
        distanceTraveled: parseFloat(values.distanceTraveled),
        description: values.description || "",
        isComplete: false,
      };
      setFilterdata({
        startDateTime: values.startDateTime?.toISOString() || "",
        endDateTime: values.endDateTime?.toISOString() || "",
        tripType : values.tripType,
        vehicleId: values.vehicleId,
        driverId: values.driverId,
        startPoint: values.startPoint,
        endPoint: values.endPoint,
        personsInTrip: Number(values.personsInTrip),
        distanceTraveled: parseFloat(values.distanceTraveled),
        description: values.description || "",
        isComplete: false,
      });
  
      // API call
      try {
        if (tripToEdit?._id) {
          // Edit mode
          await dataService.editTrip(tripToEdit._id, payload);
          notification.success({ message: "Trip updated successfully" });
          navigate("/login/trip-management");
        } else {
          // Add mode
          await dataService.addTrip(payload);
          notification.success({ message: "Trip added successfully" });
          navigate("/login/trip-management");
        }
    
       
        form.resetFields();
        setCurrent(0);
      } catch (error) {
        notification.error({
          message: "Error",
          description: error.response?.data?.message || "Something went wrong",
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const vehicles = await dataService.getAllVehicle();
      console.log("Fetched vehicles:", vehicles.data);
      const drivers = await dataService.getDriver(); 
      setVehicleList(vehicles.data);
      setDriverList(drivers.data);
    };
  
    fetchData();
  }, []);

  // Stepper control
  const next = () => setCurrent(current + 1);
  const prev = () => setCurrent(current - 1);

  return (
    <div
      style={{
        maxWidth: 1500,
        margin: "40px auto",
        padding: "20px",
        background: "#f1f8ff",
      }}
    >
      {/* Page Animation */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Icon */}
        <motion.img
          src={icon}
          alt="Trip Icon"
          style={{
            width: "40px",
            height: "40px",
            marginRight: "10px", // Space between the icon and title
            animation: "bounce 1s infinite", // Add a bounce animation for fun
          }}
          animate={{ y: [0, -5, 0] }}
          transition={{ repeat: Infinity, duration: 1.2, ease: "easeInOut" }}
        />

        {/* Title */}
        <Title level={3}>{tripToEdit ? "Edit Trip" : "Add New Trip"}</Title>
      </motion.div>

      <Card
        style={{
          borderRadius: 15,
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
          background: "#ffffff",
          border: "1px solid #e0e5ec",
          padding: "20px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Stepper with animated transitions */}
        <Steps
          current={current}
          onChange={setCurrent}
          style={{
            marginBottom: 30,
            transition: "all 0.3s ease",

            borderRadius: "10px",
            padding: "8px",
          }}
        >
          <Step
            title="Trip Dates"
            icon={
              <CalendarOutlined
                style={{ color: "#ff6347", fontSize: "24px" }}
              />
            }
            style={{ fontWeight: "bold" }}
          />
          <Step
            title="Vehicle & Driver"
            icon={
              <CarOutlined style={{ color: "#ff7043", fontSize: "24px" }} />
            }
            style={{ fontWeight: "bold" }}
          />
          <Step
            title="Locations & Trip Details"
            icon={
              <UserOutlined style={{ color: "#43a047", fontSize: "24px" }} />
            }
            style={{ fontWeight: "bold" }}
          />
          <Step
            title="Report & Submit"
            icon={
              <EditOutlined style={{ color: "#ffa000", fontSize: "24px" }} />
            }
            style={{ fontWeight: "bold" }}
          />
        </Steps>

        <Form form={form} layout="vertical" onFinish={onFinish}>
  {/* Step 1: Trip Dates */}
  <div style={{ display: current === 0 ? 'block' : 'none' }}>
    <Row gutter={16}>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item
          label="Start Date / Time"
          name="startDateTime"
         
          rules={[
            {
              required: true,
              message: "Please select start date and time!",
            },
          ]}
        >
          <DatePicker
            showTime
            style={{ width: "100%", borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item
          label="End Date / Time"
          name="endDateTime"
          rules={[
            {
              required: true,
              message: "Please select end date and time!",
            },
          ]}
        >
          <DatePicker
            showTime
            style={{ width: "100%", borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={16}>
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item label="Trip Type" name="tripType">
          <Select
           
            style={{ width: "100%", borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
          >
            <Option value="One Way" style={{ background: "#ffecf1", color: "#c76d99" }}>
              One Way
            </Option>
            <Option value="Two Way" style={{ background: "#e0f7fa", color: "#0097a7" }}>
              Two Way
            </Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
  </div>

  {/* Step 2: Vehicle & Driver */}
  <div style={{ display: current === 1 ? 'block' : 'none' }}>
    <Row gutter={16}>
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
      <Form.Item
  label="Vehicle"
  name="vehicleId"
  rules={[{ required: true, message: "Please select a vehicle!" }]}
>
  <Select
    placeholder="Select a vehicle"
    style={{ width: "100%", borderRadius: "8px" }}
    loading={vehicleList.length === 0}
  >
    {vehicleList.map((vehicle) => (
      <Select.Option key={vehicle._id} value={vehicle._id}>
        {vehicle.makeAndModel }-{vehicle.registrationNum}
      </Select.Option>
    ))}
  </Select>
</Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item
          label="Driver"
          name="driverId"
          rules={[{required: true, message: "Please select a driver!" }]}
        >
          <Select
            placeholder="Select a driver"
            style={{ width: "100%", borderRadius: "8px" }}
            loading={driverList.length === 0}
          >
            {driverList.map((driver) => (
              <Select.Option key={driver._id} value={driver._id}>
                {driver.driverName} - {driver.driverPhoneNumber}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  </div>

  {/* Step 3: Locations & Trip Details */}
  <div style={{ display: current === 2 ? 'block' : 'none' }}>
    <Row gutter={16}>
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item label="Start Point" name="startPoint" rules={[{ message: "Please input the start point!" }]}>
          <Input
            placeholder="Enter start point"
            style={{ borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
            rules={[{ required: true, message: "Please input the start point!" }]}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item label="End Point" name="endPoint" rules={[{ message: "Please input the end point!" }]}>
          <Input
            placeholder="Enter end point"
            rules={[{ required: true, message: "Please input the end point!" }]}
            style={{ borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={16}>
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item label="Persons in Trip" name="personsInTrip"  rules={[
    { required: true, message: "Please enter the number of persons!" },
    {
      validator: (_, value) =>
        !value || /^[0-9]+$/.test(value)
          ? Promise.resolve()
          : Promise.reject("Only numeric values are allowed!"),
    },
  ]}>
          <Input
          type="number"
            placeholder="Enter number of persons"
            rules={[{ required: true, message: "Please enter the number of persons!" }]}
            style={{ borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
          />
        </Form.Item>
      </Col>
    {tripToEdit && (
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
      <Form.Item label="Distance Travelled"  name="distanceTraveled" rules={[{required: true, message: "Please enter the distance travelled!" }]}>
        <Input
          placeholder="Enter distance"
          rules={[{ required: true, message: "Please enter the distance travelled!" }]}
          style={{ borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
        />
      </Form.Item>
    </Col>
    )}
      
    </Row>
    <Row gutter={16}>
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item label="Stopage / Locations Covered" name="locationsCovered">
          <Upload
            action="/upload"
            listType="picture"
            showUploadList={{ showRemoveIcon: true }}
            style={{ borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
          >
            <Button icon={<PictureOutlined />}>Upload Images</Button>
          </Upload>
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={16}>
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item label="Description" name="description" rules={[{required: true, message: "Please provide a description!" }]}>
          <TextArea
            placeholder="Enter a description for the trip"
            rows={4}
            style={{ borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
          />
        </Form.Item>
      </Col>
    </Row>
  </div>

  {/* Step 4: Report & Submit */}
  <div style={{ display: current === 3 ? 'block' : 'none' }}>
    <Row gutter={[16, 16]}>
    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item label="Report" name="report">
          <Upload
            action="/upload"
            listType="picture"
            showUploadList={{ showRemoveIcon: true }}
            style={{ borderRadius: "8px", border: "1px solid #ddd", transition: "all 0.3s ease" }}
          >
            <Button icon={<PictureOutlined />}>Upload Report (Image)</Button>
          </Upload>
        </Form.Item>
      </Col>
    </Row>
  </div>

  {/* Navigation Buttons */}
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    {current > 0 && (
      <Button style={{ borderColor: colors.button, color: colors.button }} onClick={prev}>
        Previous
      </Button>
    )}
    {current < 3 && (
      <Button type="primary" style={{ backgroundColor: colors.button }} onClick={next}>
        Next
      </Button>
    )}
    {current === 3 && (
     <Button
     type="primary"
     style={{ backgroundColor: colors.button }}
     onClick={() => {
       form
         .validateFields()
         .then((values) => {
           console.log("Form is valid:", values);
           onFinish(values);
         })
         .catch((err) => {
           console.warn("Form validation failed:", err);
         });
     }}
   >
     Submit
   </Button>
    )}
  </div>
</Form>

      </Card>
    </div>
  );
};

export default AddTrip;
